import path from 'path'
import tenant from "@shared/lib/Http.js"
window.$tenant = tenant

window.getModules = (pathToFolder) => {

    let moduleFiles = require.context("./modules", true, /\.js$/)

    let modules = moduleFiles.keys().reduce((modules, module) => {
        let modulePath = module.replace('./', '')
        let moduleArray = modulePath.split("/");
        let moduleName = _.snakeCase(path.parse(modulePath).name)

        if (typeof pathToFolder == "undefined") {
            if (_.size(moduleArray) == 1) {
                modules[moduleName] = moduleFiles(module).default
            }
        } else {

            // force the path to folder to be an array if not already
            if (!_.isArray(pathToFolder)) {
                pathToFolder = [pathToFolder]
            }

            // loop through each module path and add the modules
            pathToFolder.forEach(path => {
                let folderArray = path.split(".")
                let folderCount = _.size(folderArray)
                if (folderCount > 1) {
                    let selectedModule = folderArray.pop()
                    if (selectedModule == moduleName) {
                        modules[moduleName] = moduleFiles(module).default
                    }
                } else {
                    moduleArray = moduleArray.slice(-2)
                    if (moduleArray[0] == folderArray[0]) {
                        modules[moduleName] = moduleFiles(module).default
                    }
                }
            })
        }
        return modules
    }, {})

    return modules
}

export default {
    appStore: {
        namespaced: true,
        state: {
            application: {}
        },
        modules: getModules()
    }
}
